import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import { api, setToken } from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { Lock } from "lucide-react";

export const OwnerLoginModal = ({ open, onOpenChange }) => {
  const { t } = useLang();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { password });
      setToken(data.token);
      onOpenChange(false);
      setPassword("");
      navigate("/owner");
    } catch (err) {
      setError(t("owner.wrongPassword"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="owner-login-modal">
        <DialogHeader>
          <div className="mx-auto mb-2 flex h-12 w-12 items-center justify-center rounded-full bg-[#C85A32]/10 text-[#C85A32]">
            <Lock className="h-6 w-6" />
          </div>
          <DialogTitle className="text-center font-serif text-2xl">{t("owner.loginTitle")}</DialogTitle>
          <DialogDescription className="text-center">{t("owner.loginSubtitle")}</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4 pt-2">
          <Input
            data-testid="owner-password-input"
            type="password"
            autoFocus
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
          />
          {error && <p className="text-sm text-red-600" data-testid="owner-login-error">{error}</p>}
          <Button
            data-testid="owner-login-submit"
            type="submit"
            disabled={loading || !password}
            className="w-full bg-[#C85A32] hover:bg-[#B04B26] text-white"
          >
            {loading ? t("owner.loggingIn") : t("owner.login")}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
